module.exports = __webpack_public_path__ + "static/img/activity55.f0b32ee6.png";